"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PremiumDuplexBanner;
const react_1 = __importDefault(require("react"));
const Button_1 = require("@JohnLewisPartnership/jl-design-system/dist/components/button/Button");
const PremiumDuplexBanner_module_scss_1 = __importDefault(require("./PremiumDuplexBanner.module.scss"));
const dispatchAnalytics_1 = require("../../../utils/dispatchAnalytics");
const constants_1 = require("../../../constants");
function PremiumDuplexBanner({ ctaText, ctaLink, clickUrl, impressionUrl, logoImage, description, desktopImage, accessibilityText, logoAccessibilityText, associatedAdvertId, esiType, }) {
    return (react_1.default.createElement("a", { href: ctaLink, className: PremiumDuplexBanner_module_scss_1.default.bannerLink, "data-testid": "nav-flyout-premium-duplex-banner-link", onClick: () => {
            (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)({
                action: "kevel.clicked",
                type: "banner",
                adId: associatedAdvertId,
                clickUrl,
                impressionUrl,
                esiType,
            });
        } },
        react_1.default.createElement("div", { className: PremiumDuplexBanner_module_scss_1.default.contentContainer },
            react_1.default.createElement("div", { className: PremiumDuplexBanner_module_scss_1.default.logoArea },
                react_1.default.createElement("img", { src: logoImage, className: PremiumDuplexBanner_module_scss_1.default.logo, alt: logoAccessibilityText, "data-testid": "nav-flyout-premium-duplex-banner-logo" })),
            react_1.default.createElement("p", { className: PremiumDuplexBanner_module_scss_1.default.description, "data-testid": "nav-flyout-premium-duplex-banner-description" }, description.substring(0, constants_1.PREMIUM_DUPLEX_DESC_CHAR_LIMIT))),
        react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", className: PremiumDuplexBanner_module_scss_1.default.cta, labelText: ctaText, "data-testid": "nav-flyout-premium-duplex-banner-cta" }),
        react_1.default.createElement("picture", null,
            react_1.default.createElement("source", { type: "image/webp", srcSet: `
            ${desktopImage}?w=379&h=106&fmt=webp 1x,
            ${desktopImage}?w=758&h=212&fmt=webp 2x
          ` }),
            react_1.default.createElement("img", { "data-testid": "nav-flyout-premium-duplex-banner-image", src: `${desktopImage}?w=379&h=106&fmt=webp`, srcSet: `
            ${desktopImage}?w=379&h=106&fmt=webp 1x,
            ${desktopImage}?w=758&h=212&fmt=webp 2x
          `, className: PremiumDuplexBanner_module_scss_1.default.image, alt: accessibilityText, loading: "lazy", decoding: "async" }))));
}
